import { createRouter, createWebHistory } from '@ionic/vue-router';
import { allRoutes } from './routes';
import { authGuard } from './guards/authGuard';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoutes,
});

// Application du guard d'authentification
router.beforeEach(authGuard);

// Exports des utilitaires
export { UserRole, ROUTE_CATEGORY } from './types';
export { useAppRouter } from './composables/useAppRouter';
export {
  getHomeRouteForRole,
  getRoutesForRole,
  canAccessRoute,
  getRoutesByCategory,
} from './routes';

export default router;
